// Helper function to generate empty rows
const generateEmptyRows = (count = 14) => {
  let rows = '';
  for (let i = 0; i < count; i++) {
    rows += `
      <tr style="height: 15px;">
        <td style="border-bottom: 2px solid #ddd;">&nbsp;</td>
        <td style="border-bottom: 2px solid #ddd;">&nbsp;</td>
        <td style="border-bottom: 2px solid #ddd; text-align: right;">&nbsp;</td>
        <td style="border-bottom: 2px solid #ddd; text-align: right;">&nbsp;</td>
      </tr>
    `;
  }
  return rows;
};

// Helper function to get lab address
const getLabAddress = (labInfo) => {
  if (labInfo?.address) return labInfo.address;
  return "02 Ulverscroft Road";
};

const getLabCity = (labInfo) => {
  if (labInfo?.city) return labInfo.city;
  return "Coventry";
};

const getLabState = (labInfo) => {
  return labInfo?.state || "";
};

const getLabZip = (labInfo) => {
  return labInfo?.zipCode || "CV3 5EZ";
};
const formatShipperText = (shipper) => {
  if (!shipper) return "";

  const words = shipper.trim().split(/\s+/);

  if (words.length <= 4) {
    return shipper;
  }

  let result = "";

  words.forEach((word, index) => {
    if (index > 0) {
      if (index % 4 === 0) {
        result += "<br>";
      } else {
        result += " ";
      }
    }
    result += word;
  });

  return result;
};
const getLabTelephone = (labInfo) => {
  if (labInfo?.telephone) return labInfo.telephone;
  return "024 7642 2500";
};

const now = new Date();
const printTimestamp = now.toLocaleString('en-GB', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false
});

// Main function to generate invoice HTML
export const generateInvoiceHTML = ({ invoices, accountList, caseMap, labInfo }) => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Invoices</title>
  <style>
    @page { 
      size: A4; 
      margin: 10mm 0 0 0;
    }
    
    body {
      font-family: Arial, sans-serif;
      margin: 0;
      padding: 0;
      background: #fff;
      text-align: left;
      -webkit-print-color-adjust: exact;
    }

    .page-wrapper {
      width: 1000px;
      min-width: 1000px;
      max-width: 1000px;
      margin: 0;
      padding: 0;
    }
    
    .invoice {
      width: 1000px;
      max-width: 1000px;
      min-width: 1000px;
      font-size: 14px;
      padding: 10mm;
      box-sizing: border-box;
      page-break-after: always;
      page-break-inside: avoid;
      position: relative;
      min-height: 297mm;
      display: block;
    }
    
    .content-header { 
      display: flex; 
      justify-content: space-between; 
      align-items: flex-start; 
      padding-bottom: 10px; 
      margin-bottom: 15px; 
      margin-top: 15px; 
      position: relative;
    }
    
    .logo { 
      width: 190px; 
      height: auto; 
    }
    
    table { 
      width: 100%; 
      border-collapse: collapse; 
      margin-top: 10px; 
    }
    
    th, td { 
      padding: 6px 8px; 
      font-size: 16px; 
      text-align: left;  
    }
    
    th { 
      background-color: #f2f2f2; 
      font-weight: bold; 
    }
    
    td:nth-child(3), td:nth-child(4) { 
      text-align: right; 
    }
    
    .invoice-table { 
      width: 100%; 
      border-collapse: collapse; 
      margin-bottom: 25px; 
    }
    
    .invoice-table th { 
      background-color: #f4f4f4; 
      padding: 12px 15px; 
      text-align: left;  
      font-weight: bold; 
      color: black; 
      font-size: 18px; 
    }
    
    .invoice-table td { 
      padding: 15px 20px; 
      border-bottom: 2px solid #e4e7eb;   
    }
    
    .invoice-table .text-right { 
      text-align: right; 
    }
    
    .totals { 
      margin-left: auto; 
      width: 600px; 
    }
    
    .center-details {
      position: relative;
      margin-top: 20px;
      margin-bottom: 20px;
      min-height: 220px;
    }

    .center-block {
      position: absolute;
      left: 70%;
      transform: translateX(-50%);
      text-align: left;
      width: 320px;
    }

    .detail-item {
      margin: 8px 0;
      display: block;
    }

    .right-shift-block {
      position: absolute;
      left: 80%;
      top: 0;
      text-align: left;
      max-width: 200px;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .print-only-info {
      display: none;
    }

    .print-only-center {
      display: none;
    }
    
    .print-header-row {
      display: none;
    }
    
    /* Print Timestamp - hidden on screen, visible on print */
    .print-timestamp {
      display: none;
    }
    
    .print-center {
      flex: 1;
      text-align: center;
      padding-left: 290px;
    }

    .print-center-inner {
      display: flex;
      flex-direction: column;
      gap: 6px;
      font-weight: 500;
    }

    .print-right {
      position: absolute;
      right: 8px;
      text-align: right;
      font-size: 14px;
      top: 22%;
      max-width: 300px;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    /* Shipper container with label and text */
    .shipper-container {
      display: inline-block;
      max-width: 300px;
      text-align: left;
    }

    .shipper-label {
      font-weight: bold;
      display: inline;
    }

    .shipper-text {
      word-wrap: break-word;
      overflow-wrap: break-word;
      display: inline;
    }

    .shipper-text br {
      display: block;
    }

    .total-row { 
      display: flex; 
      justify-content: space-between; 
      padding: 8px 0; 
    }
    
    .total-row.final { 
      border-top: 2px solid #ddd;  
    }
    
    .total-row.subtotal-taxes { 
      border-bottom: 2px solid #ddd;
      padding-bottom: 8px;
      margin-bottom: 4px;
    }
    
    /* SCREEN VIEW: print rows hide */
    .print-only-total {
      display: none;
    }
    
    /* Patient name styling */
    .patient-name {
      word-wrap: break-word;
      overflow-wrap: break-word;
      max-width: 250px;
      display: inline-block;
    }

    /* Right shift block shipper styling - MODIFIED */
    .right-shift-block .shipper-container {
      max-width: 180px;
    }

    .right-shift-block .shipper-text {
      max-width: 180px;
    }

    @media print {

      .center-details {
        display: none !important;
      }
      
      /* Print Timestamp - visible only on print */
      .print-timestamp {
        display: block !important;
        text-align: left;
        color: #000000;
        margin-bottom: 10px;
        padding-left: 5px;
      }

      .print-header-row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 5px;
        margin-bottom: 8px;
        padding-bottom: 5px;
        position: relative;
      }

      /* CENTER BLOCK */
      .print-center {
        flex: 1;
        display: flex;
        justify-content: center;
      }

      .print-center-inner {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        font-size: 14px;
        min-width: 200px;
      }

      .print-center-inner div {
        display: flex;
        gap: 5px;
      }

      .print-right {
        font-size: 14px;
        text-align: right;
        align-self: flex-start;
        max-width: 300px;
        word-wrap: break-word;
        overflow-wrap: break-word;
      }

      /* Print shipper container - label stays with text */
      .print-right .shipper-container {
        display: inline-block;
        max-width: 280px;
        text-align: left;
      }

      .print-right .shipper-label {
        font-weight: bold;
        display: inline;
      }

      .print-right .shipper-text {
        max-width: 280px;
        word-wrap: break-word;
        overflow-wrap: break-word;
        display: inline;
      }
      
      .invoice-table th,
      .invoice-table td {
        border: 1px solid #3D3D3D !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
        background: transparent !important;
        text-align: center !important;
      }

      /* Description column - wider (50% of table) */
      .invoice-table th:first-child,
      .invoice-table td:first-child {
        width: 70%;
        text-align: left;
      }
         /* Remove only the border between Description and QTY */
      .invoice-table th:first-child,
      .invoice-table td:first-child {
        border-right: none !important;
      }
      
      .invoice-table th:nth-child(2),
      .invoice-table td:nth-child(2) {
        border-left: none !important;
      }

      /* QTY column - narrow */
      .invoice-table th:nth-child(2),
      .invoice-table td:nth-child(2) {
        width: 15%;
        text-align: center;
      }

      /* Rate column - narrow */
      .invoice-table th:nth-child(3),
      .invoice-table td:nth-child(3) {
        width: 17.5%;
        text-align: right;
      }

      /* Total column - narrow */
      .invoice-table th:nth-child(4),
      .invoice-table td:nth-child(4) {
        width: 17.5%;
        text-align: right;
      }
      
      .invoice-table td:first-child {
        text-align: left !important;
      }
      
      .totals {
        display: none !important;
      }

      /* show totals inside table */
      .print-only-total {
        display: table-row !important;
      }

      .print-only-total td {
        border-top: 2px solid #ddd !important;
      }

      .print-only-total.final td {
        border-top: 2px solid #3D3D3D !important;
        border-bottom: 2px solid #3D3D3D !important;
      }
      
      .print-only-total td {
        border-top: 1px solid #3D3D3D !important;
        padding: 6px;
      }
      
      .print-only-total td:nth-child(2) {
        border-right: none !important;
      }

      .print-only-total td:nth-child(3) {
        border-left: none !important;
      }

      /* Subtotal Row */
      .print-only-total.subtotal td {
        border-top: 2px solid #3D3D3D !important;
      }

      /* Final Total Row */
      .print-only-total.final td {
        border-top: 2px solid #3D3D3D !important;
        border-bottom: 2px solid #3D3D3D !important;
      }
      
      .print-only-total td:first-child {
        border-top: none !important;
        border-bottom: none !important;
      }
      
      .print-only-total.subtotal td {
        border-top: 2px solid #3D3D3D !important;
      }
      
      /* Subtotal + Taxes rows */
      .print-only-total.subtotal td:first-child,
      .print-only-total.taxes td:first-child {
        border-top: none !important;
        border-bottom: none !important;
      }

      /* Total row */
      .print-only-total.final td:first-child {
        border-top: none !important;
        border-bottom: 2px solid #3D3D3D !important;
      }
    }
  </style>
</head>
<body>
  <div class="page-wrapper">
    ${invoices.map(invoice => {
      const accountDetails = accountList.find(acc => acc.account_name === invoice.accountHolder);
      const caseDetails = caseMap[invoice.caseId];
      const providerName = (caseDetails?.provider_name || "").toUpperCase();
      const city = accountDetails?.city || "";
      const state = accountDetails?.state || "";
      const zip = accountDetails?.zipcode || accountDetails?.zip || "";
      
      const formatPatientName = (firstName, lastName) => {
        const fullName = `${firstName || ""} ${lastName || ""}`.trim();
        
        const words = fullName.split(/\s+/);
        
        let formattedName = "";
        
        words.forEach((word, index) => {
          if (index > 0 && index % 3 === 0) {
            formattedName += "<br/>";
          } else if (index > 0) {
            formattedName += " ";
          }
          
          formattedName += word;
        });
        
        return formattedName.replace(
          /(Smop ID\s*:\s*)(\d+)/i,
          (match, label, id) => `${label}<br/>${id}`
        );
      };

      let locationString = [city, state, zip].filter(Boolean).join(", ");
      if (locationString) locationString = locationString.trim();
      
      // Invoice ke ander - formatted shipper
      const formattedShipper = formatShipperText(invoice.shipper);
      
      // Check if shipper exists and is not empty
      const hasShipper = invoice.shipper && invoice.shipper.trim() !== "";
      
      return `
        <div class="invoice">
          <div class="content-header">
            <div style="display: flex; flex-direction: column; align-items: flex-start; margin-bottom: 10px;">
              <b>Hira Dental Laboratory</b>
              ${getLabAddress(labInfo)}<br/>
              ${getLabCity(labInfo)}, ${getLabState(labInfo)} ${getLabZip(labInfo)}<br/>
              Tel: ${getLabTelephone(labInfo)}
            </div>
            <div
              style="
                position:absolute;
                left:65%;
                transform:translateX(-50%);
                text-align:center;
              "
            >
              <img
                class="logo"
                src="/log.png"
                alt="HIRA DENTAL LABORATORY"
                onerror="this.style.display='none'"
              />
            </div>
          </div>
          <div style="display: flex; flex-direction: row; align-items: center; margin: 0; padding: 0; position: relative;">
            <div style="margin-right: 20px;">
              <p>${providerName}</p>
              <b style="margin: 0; padding: 0;">${(invoice.accountHolder).toUpperCase()}</b>
              <p style="margin: 0 0 5px 0; padding: 0;">${(accountDetails?.address || "").toUpperCase()}</p>
              ${locationString ? `<p style="margin: 0 0 5px 0; padding: 0;">${locationString.toUpperCase()}</p>` : ''}
            </div>
            <div
              style="
                position:absolute;
                left:64%;
                transform:translateX(-50%);
                text-align:left;
                line-height:1.2;
              "
            >
              <div style="font-size:20px;">
                Invoice: ${invoice.invoiceNumber}
              </div>
              <div style="font-size:20px;margin-top:2px;">
                Case: ${invoice.caseId}
              </div>
            </div>
          </div>
          
          <!-- PRINT ONLY HEADER (Date + Patient + Shipper - only if shipper exists) -->
          <div class="print-header-row">
            <div class="print-center">
              <div class="print-center-inner">
                <div>
                  <strong>Date:</strong> 
                  <span>${invoice.invoiceDate ? new Date(invoice.invoiceDate).toLocaleDateString("en-GB") : ""}</span>
                </div>
                <div>
                  <strong>Patient:</strong> 
                  <span class="patient-name">
                    ${formatPatientName(invoice.patientFirstName, invoice.patientLastName)}
                  </span>
                </div>
              </div>
            </div>

            <!-- RIGHT - Shipper label and text in same container (only if shipper exists) -->
            ${hasShipper ? `
            <div class="print-right">
              <div class="shipper-container">
                <strong class="shipper-label">Shipper:</strong>
                <span class="shipper-text">${formattedShipper}</span>
              </div>
            </div>
            ` : ''}
          </div>
          
          <!-- SCREEN ONLY: All invoice details centered -->
          <div class="center-details">
            <!-- CENTER BLOCK -->
            <div class="center-block">
              <div class="detail-item">
                <strong>Date:</strong>
                ${new Date(invoice.invoiceDate || "2025-08-04").toLocaleDateString()}
              </div>
              <div class="detail-item">
                <strong>Patient:</strong>
                ${invoice.patientFirstName || ""} ${invoice.patientLastName || ""}
              </div>
              <div class="detail-item">
                <strong>Invoice Date</strong>
                <div style="margin-top:5px; margin-left:15px;">
                  ${invoice.invoiceDate
                    ? new Date(invoice.invoiceDate).toLocaleDateString("en-GB")
                    : ""}
                </div>
              </div>
              <div class="detail-item">
                <strong>Provider</strong>
                <div style="margin-top:5px; margin-left:15px;">
                  ${providerName}
                </div>
              </div>
              <div class="detail-item">
                <strong>Patient</strong>
                <div style="margin-top:5px; margin-left:15px; color:#004aad; font-weight:bold;">
                  ${invoice.patientFirstName || ""} ${invoice.patientLastName || ""}
                </div>
              </div>
              <div class="detail-item">
                <strong>Tracking Ref#</strong>
                <div style="margin-top:5px; margin-left:15px;">
                  ${invoice.trackNumber || ""}
                </div>
              </div>
            </div>

            <!-- RIGHT SHIFT BLOCK - Shipper (only if shipper exists) -->
            ${hasShipper ? `
            <div class="right-shift-block">
              <div class="detail-item">
                <div class="shipper-container">
                  <strong>Shipper:</strong>
                  <span class="shipper-text">${invoice.shipper || ""}</span>
                </div>
              </div>
              <div class="detail-item">
                <strong>Tracking Ref#:</strong>
                ${invoice.trackNumber || ""}
              </div>
            </div>
            ` : `
            <div class="right-shift-block">
              <div class="detail-item">
                <strong>Tracking Ref#:</strong>
                ${invoice.trackNumber || ""}
              </div>
            </div>
            `}
          </div>
          
          <table class="invoice-table">
            <thead>
              <tr>
                <th>Description</th>
                <th>QTY</th>
                <th class="text-right">Rate</th>
                <th class="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              ${(invoice.items || []).map(item => `
                <tr>
                  <td>${item.description || ""}</td>
                  <td>${item.quantity || 0}</td>
                  <td class="text-right">£${item.quantity ? (item.amount / item.quantity).toFixed(2) : "0.00"}</td>
                  <td class="text-right">£${item.amount ? item.amount.toFixed(2) : "0.00"}</td>
                </tr>
              `).join('')}
              ${generateEmptyRows(14)} 
              
            </tbody>
            <!-- PRINT ONLY TOTAL ROWS -->
            <tr class="print-only-total subtotal">
              <td></td>
              <td></td>
              <td style="text-align:left; color:#3D3D3D;">
                Subtotal
              </td>
              <td style="text-align:right; color:#3D3D3D;">
                £${(invoice.subtotal || 0).toFixed(2)}
              </td>
            </tr>

            <tr class="print-only-total taxes">
              <td></td>
              <td style="text-align:left; color:#3D3D3D;">
                Taxes
              </td>
              <td></td>
              <td style="text-align:right; color:#3D3D3D;">
                £${(invoice.taxes || 0).toFixed(2)}
              </td>
            </tr>

            <tr class="print-only-total final">
              <td></td>
              <td></td>
              <td style="text-align:left; color:#3D3D3D;">
                Total
              </td>
              <td style="text-align:right; color:#3D3D3D;">
                £${(invoice.total || 0).toFixed(2)}
              </td>
            </tr>
          </table>
          
          <div class="totals">
            <div class="total-row subtotal-taxes">
              <span>Subtotal</span>
              <span>£${(invoice.subtotal || 0).toFixed(2)}</span>
            </div>
            <div class="total-row">
              <span>Taxes</span>
              <span>£${(invoice.taxes || 0).toFixed(2)}</span>
            </div>
            <div class="total-row final">
              <span>Total</span>
              <span>£${(invoice.total || 0).toFixed(2)}</span>
            </div>
          </div>
        </div>
      `;
    }).join('')}
  </div>
</body>
</html>
  `;
};